import clamp from 'lodash/clamp';
import { EventConfig } from 'models/types/eventConfig';
import {
  ConversationMetadata,
  ConversationType,
  UserReachabilityStatus,
} from './types';

export const calculateUnread = (metadata: ConversationMetadata, eventConfig?: EventConfig) => {
  if (eventConfig && eventConfig?.chatroomConfig?.isBoothChatroomDisabled
    && metadata?.conversationType === ConversationType.GROUP) {
    return 0;
  }
  const lastMessageIndex = metadata?.lastMessage?.index ?? -1;
  const lastReadMessageIndex = metadata?.lastReadMessageIndex ?? -1;
  const unreadCount = lastMessageIndex - lastReadMessageIndex;

  return clamp(unreadCount, 0, Number.MAX_SAFE_INTEGER);
};

export const determineReachabilityStatus = (
  isOnline: boolean,
  isIdle: boolean,
): UserReachabilityStatus => {
  if (!isOnline) return UserReachabilityStatus.OFFLINE;
  if (isOnline && !isIdle) return UserReachabilityStatus.ONLINE;
  return UserReachabilityStatus.IDLE;
};
